import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import logo from "../../Utils/Assests/New.png";
import facebook from "../../Utils/Assests/FB.png";
import instagram from "../../Utils/Assests/INSTA.png";
import youtube from "../../Utils/Assests/YOU.png";

const Footer = ({ initialContent }) => {
  const navigate = useNavigate();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [initialContent]);

  const linkGroups = {
    Resources: [
      { name: "BWORKZ", href: "https://bworkzlive.com/" },
      {
        name: "Instructor Brochure",
        href: "https://s3-us-east-2.amazonaws.com/bworkzdocuments/brochure.pdf",
      },
      {
        name: "Instructor Application",
        href: "https://forms.gle/ahVeu2pSjJdWbADVA",
      },
      {
        name: "In Person BWORKZ classes",
        href: "https://movatiathletic.com/",
      },
    ],
    Partners: [
      { name: "HappyPrancer", href: "https://happyprancer.com/" },
      { name: "Lissome", href: "http://lissome.happyprancer.com" },
      {
        name: "Anupamz",
        href: "https://www.facebook.com/share/XBcvvs7ZENoqDReS/?mibextid=ox5AEW",
      },
      { name: "ACE", href: "https://www.acefitness.org/" },
    ],
    "Quick Links": [
      { name: "Contact Us", onClick: () => navigate("/query") },
      { name: "About Us", onClick: () => navigate("/aboutUs") },
    ],
  };

  const renderLinkColumn = (title, links) => (
    <div key={title} className="flex flex-col gap-3 min-w-[10rem]">
      <h2 className="text-left text-white font-semibold">{title}</h2>
      <div
        className="h-[3px] w-full"
        style={{
          background: "linear-gradient(90deg, #FFD700 16.67%, #353534 90.74%)",
        }}
      />
      {links.map((link, index) =>
        link.onClick ? (
          <p
            key={index}
            onClick={link.onClick}
            className="cursor-pointer text-[#fff] text-decoration-none mb-0 hover:text-[#FDCF08] transition-colors"
          >
            {link.name}
          </p>
        ) : (
          <a
            key={index}
            href={link.href}
            target="_blank"
            rel="noreferrer"
            className="cursor-pointer text-[#fff] text-decoration-none hover:text-[#FDCF08] transition-colors"
          >
            {link.name}
          </a>
        )
      )}
    </div>
  );

  const handleNavigation = (path) => {
    navigate(path);
  };

  return (
    <footer className="bg-black text-white font-poppins">
      <div className="flex flex-wrap justify-between gap-10 px-6 py-12 lg:px-12">
        {/* Logo Section */}
        <div className="w-full md:w-auto flex justify-center md:justify-start">
          <a href="/">
            <img src={logo} alt="Logo" className="w-60 object-contain" />
          </a>
        </div>

        {/* Links Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-10 w-full md:w-auto">
          {Object.entries(linkGroups).map(([title, links]) =>
            renderLinkColumn(title, links)
          )}
        </div>
      </div>

      {/* Social Media */}
      <div className="bg-[#FDCF08] py-1 px-6 flex justify-center">
        <div className="flex gap-6 bg-black rounded-full px-4 py-2 items-center">
          <a
            href="https://instagram.com/bworkz_workout?igshid=YmMyMTA2M2Y"
            target="_blank"
            rel="noreferrer"
          >
            <img
              src={instagram}
              alt="Instagram"
              className="w-8 h-8 transition-transform duration-300 hover:scale-110"
            />
          </a>
          <a
            href="https://www.facebook.com/BworkZLive?mibextid=LQQJ4dY"
            target="_blank"
            rel="noreferrer"
          >
            <img
              src={facebook}
              alt="Facebook"
              className="w-8 h-8 transition-transform duration-300 hover:scale-110"
            />
          </a>
          <a
            href="https://youtube.com/@bworkzworkout2004"
            target="_blank"
            rel="noreferrer"
          >
            <img
              src={youtube}
              alt="YouTube"
              className="w-8 h-8 transition-transform duration-300 hover:scale-110"
            />
          </a>
        </div>
      </div>

      {/* Bottom Links */}
      <div className="text-sm text-center flex flex-wrap justify-center gap-4 py-4 px-2 border-t border-gray-700">
        <div
          className="cursor-pointer hover:text-[#FDCF08]"
          onClick={() => handleNavigation("/privacy")}
        >
          Privacy Policy
        </div>
        <span className="text-[#FDCF08]">|</span>
        <div
          className="cursor-pointer hover:text-[#FDCF08]"
          onClick={() => handleNavigation("/terms")}
        >
          Terms & Conditions
        </div>
        <span className="text-[#FDCF08]">|</span>
        <div
          className="cursor-pointer hover:text-[#FDCF08]"
          onClick={() => handleNavigation("/refund")}
        >
          Cancellation/Refund Policy
        </div>
        <span className="text-[#FDCF08]">|</span>
        <div className="text-white">
          &copy; {new Date().getFullYear()} bworkzlive.com. All rights reserved.
        </div>
      </div>
    </footer>
  );
};

export default Footer;
